import type {ComponentEnhancer} from 'recompose'
import {branch as branchHOC} from 'recompose'

import compose from 'lodash/flowRight'
import {memo} from 'react'
import {connect} from 'react-redux'

import {subscribeOnBuildTypeStatus, subscribeOnProjectStatus} from '../actions/statuses'
import {withBranchProps} from '../hooks/routes'
import useStatusSubscription from '../hooks/useStatusSubscription'
import type {State} from '../reducers/types'
import {getBuildType, getProject} from '../selectors'
import type {Branch} from '../services/rest'
import type {
  BuildTypeId,
  BuildTypeInternalId,
  ProjectId,
  ProjectInternalId,
  ActiveEntityProps,
  Enhancer,
} from '../types'

import withHook from './withHook'

type OwnProps = ActiveEntityProps & {
  branch?: Branch | null
  withoutBranch?: boolean
  blockUpdates?: boolean
  updateOverviewParents?: boolean
}
type StateProps = {
  projectInternalId: ProjectInternalId | null | undefined
  buildTypeInternalId: BuildTypeInternalId | null | undefined
}
type SubscribeProject = (
  id: ProjectId,
  internalId: ProjectInternalId,
  branch?: Branch | null,
  timeout?: number,
  fetchOverviewParents?: boolean | null,
) => () => unknown
export type SubscribeBuildType = (
  id?: BuildTypeId,
  internalId?: BuildTypeInternalId,
  branch?: Branch | null | undefined,
  timeout?: number | void,
) => () => unknown
type ActionProps = {
  subscribeProject: SubscribeProject
  subscribeBuildType: SubscribeBuildType
}
export type StatusSubscriptionProps = StateProps & ActionProps
type Props = OwnProps & StatusSubscriptionProps
export default <P extends OwnProps>(timeout?: number): Enhancer<StatusSubscriptionProps, P> =>
  compose(
    memo,
    branchHOC(
      (props: P) => props.branch == null && props.withoutBranch !== true,
      withBranchProps as ComponentEnhancer<OwnProps, OwnProps>,
    ),
    connect(
      (state: State, {projectId, buildTypeId}: OwnProps): StateProps => ({
        projectInternalId: getProject(state, projectId)?.internalId,
        buildTypeInternalId: getBuildType(state, buildTypeId)?.internalId,
      }),
      {
        subscribeProject: subscribeOnProjectStatus,
        subscribeBuildType: subscribeOnBuildTypeStatus,
      },
    ),
    withHook((props: Props) => {
      useStatusSubscription({
        ...props,
        timeout,
      })
    }),
  )
